import { render } from "./RecentErrands.vue?vue&type=template&id=500594b0&scoped=true"
import script from "./RecentErrands.vue?vue&type=script&lang=js"
export * from "./RecentErrands.vue?vue&type=script&lang=js"

import "./RecentErrands.vue?vue&type=style&index=0&id=500594b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500594b0"]])

export default __exports__